module.exports = __webpack_public_path__ + "img/stamp-island-designer-blue.c59e0dea.png";